/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type TouchpointDTOContentType =
  (typeof TouchpointDTOContentType)[keyof typeof TouchpointDTOContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TouchpointDTOContentType = {
  AD_HOC: "AD_HOC",
  AD_HOC_CUSTOM: "AD_HOC_CUSTOM",
  APP_NUDGE: "APP_NUDGE",
  APP_TIPS: "APP_TIPS",
  APPLICATION_DEADLINE: "APPLICATION_DEADLINE",
  ATTENTION: "ATTENTION",
  CLICKER: "CLICKER",
  CONTENT_TOPIC: "CONTENT_TOPIC",
  DEADLINE_REOPENING: "DEADLINE_REOPENING",
  DEPOSIT_DEADLINE: "DEPOSIT_DEADLINE",
  DEPOSIT_PUSH: "DEPOSIT_PUSH",
  DOMAIN_WARMUP: "DOMAIN_WARMUP",
  EARLY_APP_OPENING: "EARLY_APP_OPENING",
  ENGAGEMENT: "ENGAGEMENT",
  ENROLL: "ENROLL",
  EVENT: "EVENT",
  FAFSA: "FAFSA",
  FIRST_STEP: "FIRST_STEP",
  INFO_ASK: "INFO_ASK",
  INQUIRY_TRANSITION: "INQUIRY_TRANSITION",
  INTRO_PROGRAM: "INTRO_PROGRAM",
  INVITE_TO_APPLY_ONGOING: "INVITE_TO_APPLY_ONGOING",
  MAIL_SUPPORT_CAMPAIGN: "MAIL_SUPPORT_CAMPAIGN",
  MICRO_CAMPAIGN: "MICRO_CAMPAIGN",
  OPPORTUNITY: "OPPORTUNITY",
  PREPARE_TO_APPLY: "PREPARE_TO_APPLY",
  PRE_COLLEGE_REOPENING: "PRE_COLLEGE_REOPENING",
  PROGRAM_START: "PROGRAM_START",
  PULSE_CHECK: "PULSE_CHECK",
  PULSE_CHECK_RESPONSE: "PULSE_CHECK_RESPONSE",
  QUICK_TIPS: "QUICK_TIPS",
  SUPPLEMENTAL: "SUPPLEMENTAL",
  VISIT_PUSH: "VISIT_PUSH",
} as const;
